<template>
  <div v-show="menuActive" class="action-menu">
    <div class="menu-backdrop" @click="closeMenu"></div>
    <div class="menu" ref="menu" @click="closeMenu">
      <button v-for="color in colors" @click="setColor(color)">
        <div
          class="swatch"
          :class="color"
          :style="'background-color: var(--card-color-' + color + ');'"
        ></div>
      </button>
    </div>
  </div>
</template>

<style scoped>
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: var(--bg-color-hover);
}
.menu {
  z-index: 15;
  position: fixed;
  border-radius: var(--rounding-smaller);
  background-color: var(--bg-color-card-default);
  border: var(--menu-border);
  display: flex;
  flex-flow: column nowrap;
}
.icon {
  flex: var(--indent-size) 0 0;
  margin: 0;
}
button {
  height: var(--indent-size);
  min-width: 150px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
button:hover {
  background: var(--bg-color-hover);
}
.menu span {
  text-align: left;
}
.swatch {
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
}
</style>

<script>
import { Item } from "../item";
import selection from "../selection";

export default {
  data() {
    return {
      menuActive: false,
      triggerEl: null,
      item: new Item({}, this.$reactiveCache, this.$defaultDB),
      colors: [
        undefined,
        "red",
        "green",
        "yellow",
        "blue",
        "violet",
        "lightgrey",
        "lightred",
        "lightorange",
        "lightyellow",
        "lightgreen",
        "lightcyan",
        "lightblue",
        "lightviolet",
        "lightpink",
      ],
    };
  },
  computed: {},
  methods: {
    setColor(color) {
      if (selection.length) {
        selection.colorAll(color);
      } else {
        this.item.clone({ color }).save();
      }
    },
    openMenu() {
      this.menuActive = true;
      this.$nextTick(() => {
        // we need the size for calculations, so it has to render first
        this.setMenuPosition(this.$refs.menu);
      });
    },
    setMenuPosition(menu) {
      const viewport = document.getElementById("toplevel").getBoundingClientRect();

      const width = menu.offsetWidth;
      if (viewport.width > this.triggerEl.left + width) {
        menu.style.left = this.triggerEl.left + "px";
        menu.style.right = "auto";
      } else if (this.triggerEl.right > width) {
        menu.style.right = viewport.width - this.triggerEl.right + "px";
        menu.style.left = "auto";
      } else {
        menu.style.left = "5vw";
        menu.style.right = "auto";
      }

      const height = menu.offsetHeight;
      if (viewport.height > this.triggerEl.top + height) {
        menu.style.top = this.triggerEl.top + "px";
        menu.style.bottom = "auto";
      } else if (this.triggerEl.bottom > height) {
        menu.style.bottom = viewport.height - this.triggerEl.bottom + "px";
        menu.style.top = "auto";
      } else {
        menu.style.bottom = "5vh";
        menu.style.top = "auto";
      }
    },
    closeMenu() {
      this.menuActive = false;
    },
  },
  mounted() {
    this.$root.$on("color-menu", (data) => {
      this.triggerEl = data.button;
      this.item = data.item;
      this.openMenu();
    });
  },
};
</script>
